var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-2 py-1.5 rounded-sm min-w-[10rem] mb-2",class:{
    'bg-slate-50 dark:bg-slate-600 dark:text-slate-50':
      _vm.messageType === _vm.MESSAGE_TYPE.INCOMING,
    'bg-woot-600 text-woot-50': _vm.messageType === _vm.MESSAGE_TYPE.OUTGOING,
    '-mx-2': !_vm.parentHasAttachments,
  }},[_c('message-preview',{attrs:{"message":_vm.message,"show-message-type":false,"default-empty-message":_vm.$t('CONVERSATION.REPLY_MESSAGE_NOT_FOUND')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }